export { default } from "./src/invisible-content";

export type { UniformInvisibleContentProps } from "./src/invisible-content";
